export default __webpack_public_path__ + "static/media/highq_v2.246aae9f.jpg";